import { EventEmitter } from '@angular/core';
import { MenuItem, MenuItems } from '../../base/models/menu-items';
import chaining from './chaining';

/**
 * Creates a simple callable function.
 * @param emitter The emitter to emit to.
 */
export function emitter(emitter: EventEmitter<any>): any {
    return emitter.emit.bind(emitter)
}

export function parseMenuIds(entries: MenuItems, type: string) {
  const ids = []
  for (const key in entries) {
    if ((entries[key]['type'] === type) || (entries[key]['type'] === 'both'))
      ids.push(key)
  }
  return ids
}

export function  parseChain(items: MenuItem[], id: string) {
  let chain = []

  chain.push(id)
  items.forEach(item => {
    item.children.forEach(child => {
      if (chaining(items.find(menu => child === menu.code), 'page') === id)
        chain = chain.concat(...findParents(items, item.page))
    })
  })
  return chain
}

export function findParents(array, id, chain = []) {
  if (id && Array.isArray(array)) {
    // Find page based on id
    const page = array.find(current => current.page === id)

    // Check page
    if (page) {
      // Check if this page is already present in the chain.
      // If it is, stop with the recursive function since it will
      // end up in an infinite loop
      if (chain && chain.length) {
        const lastPage = chain[chain.length - 1]
        if (lastPage.code === page.code) {
          return chain.map(item => item && item.page)
        }
      }

      // Push the page to the chain and find related stuff
      chain.push(page)
      const parentCode = chaining(array.find(item => item.page === id), 'parent')
      const parentPage = chaining(array.find(entry => entry.code === parentCode), 'page')
      return findParents(array, parentPage, chain)

    }
  } else {
    return chain.map(item => item && item.page)
  }
}
